<div bsModal 
     class="modal-dialog-centered" 
     tabindex="-1" 
     aria-hidden="true" 
     [config]="{ ignoreBackdropClick: true, keyboard: false }" id="downGradeModal">

    <div class="modal-content">
      <!--begin::Modal header-->
      <div class="modal-header pb-0 border-0 justify-content-end">

      </div>
      <div class="modal-body scroll-y mx-5 mx-xl-18 pt-0">
        <div class="text-center mb-13">
          <h1 class="mb-3">Mettre à jour mon compte</h1>
          <p class="text-muted">Avant de pouvoir basculer vers la nouvelle offre, Vous devez d'abord désactiver un ou plusieurs comptes consultants/intervenants. Les comptes désactivés ne pourront plus accéder à la plateforme.</p>
        </div>
        <div class="row">
          <div
            [ngClass]="{
              'text-danger': isOverLimit('Limite consultants', selectedConsultant),
              'text-success': !isOverLimit('Limite consultants', selectedConsultant),
              'col-6': isOverLimit('Limite intervenants', []),
              'col-12': !isOverLimit('Limite intervenants', [])
            }"
          >
            {{ getFormattedFeatureText('Limite consultants', selectedConsultant) }}
          </div>
          <div
            [ngClass]="{
              'text-danger': isOverLimit('Limite intervenants', selectedIntervenant),
              'text-success': !isOverLimit('Limite intervenants', selectedIntervenant),
              'col-6': isOverLimit('Limite consultants', []),
              'col-12': !isOverLimit('Limite consultants', [])
            }"
          >
            {{ getFormattedFeatureText('Limite intervenants', selectedIntervenant) }}
          </div>
        </div>

        <div class="mb-15">
          <div class="row">
            <div *ngIf=" isOverLimit('Limite consultants', [])" [ngClass]="{'col-6': isOverLimit('Limite intervenants', []), 'col-12': !isOverLimit('Limite intervenants', [])}">
              <div class="mb-5">
                <h5 class="fw-bold">Désactiver compte Consultant(s)</h5>
              </div>
            </div>
            <div *ngIf="isOverLimit('Limite intervenants', [])" [ngClass]="{'col-6': isOverLimit('Limite consultants', []), 'col-12':  !isOverLimit('Limite consultants', [])}">
              <div class="mb-5">
                <h5 class="fw-bold">Désactiver compte Intervenant(s)</h5>
              </div>
            </div>
          </div>

          <div class="row">
            <div *ngIf=" isOverLimit('Limite consultants', [])" [ngClass]="{'col-6': isOverLimit('Limite intervenants', []), 'col-12': !isOverLimit('Limite intervenants', [])}">
              <!--begin::List-->
              <div class="mh-375px scroll-y me-n7 pe-7" *ngFor="let consultant of listconsultant">
                <div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
                  <!--begin::Details-->
                  <div class="d-flex align-items-center">
                    <div class="form-check">
                      <input class="form-check-input" (change)="onCheckboxChange($event, consultant,selectedConsultant)" type="checkbox" [value]="consultant.id" id="consultant{{ consultant.id }}" />
                    </div>
                    <!--begin::Avatar-->
                    <div class="symbol symbol-35px symbol-circle">
                      <img *ngIf="consultant.image_url && consultant.image_url != 'avatar.png'" class="table-img" src="{{ urlimage + consultant.image_url }}" alt="" width="50px">
                      <img *ngIf="consultant.image_url && consultant.image_url == 'avatar.png'" class="table-img" src="{{ '/assets/media/avatar.png' }}" alt="" width="50px">
                      <img *ngIf="!consultant.image_url || consultant.image_url === undefined" class="table-img" src="{{ '/assets/media/avatar.png' }}" alt="" width="50px">
                    </div>
                    <div class="ms-6">
                      <a href="#" class="d-flex align-items-center fs-5 fw-bold text-dark text-hover-primary">
                        {{ consultant.first_name }}&nbsp;&nbsp;{{ consultant.last_name }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isOverLimit('Limite intervenants', [])" [ngClass]="{'col-6': isOverLimit('Limite consultants', []), 'col-12':  !isOverLimit('Limite consultants', [])}">
              <!--begin::List-->
              <div class="mh-375px scroll-y me-n7 pe-7" *ngFor="let intervenant of listintervenant">
                <div class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed">
                  <!--begin::Details-->
                  <div class="d-flex align-items-center">
                    <div class="form-check">
                      <input class="form-check-input" (change)="onCheckboxChange($event, intervenant,selectedIntervenant)" type="checkbox" [value]="intervenant.id" id="intervenant{{ intervenant.id }}" />
                    </div>
                    <!--begin::Avatar-->
                    <div class="symbol symbol-35px symbol-circle">
                      <img *ngIf="intervenant.image_url && intervenant.image_url != 'avatar.png'" class="table-img" src="{{ urlimage + intervenant.image_url }}" alt="" width="50px">
                      <img *ngIf="intervenant.image_url && intervenant.image_url == 'avatar.png'" class="table-img" src="{{ '/assets/media/avatar.png' }}" alt="" width="50px">
                      <img *ngIf="!intervenant.image_url || intervenant.image_url === undefined" class="table-img" src="{{ '/assets/media/avatar.png' }}" alt="" width="50px">
                    </div>
                    <div class="ms-6">
                      <a href="#" class="d-flex align-items-center fs-5 fw-bold text-dark text-hover-primary">
                        {{ intervenant.first_name }}&nbsp;&nbsp;{{ intervenant.last_name }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button
        class="confirmer"
        [disabled]="!canDowngrade()"
        (click)="downgrade()"
      >
        Confirmer la mise à jour
      </button>        
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal content-->
  </div>
